/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type group_presence_PresenceReportSegmentDTO = {
    /**
     * Corrected marks a span not recorded by a live tap (late add or admin correction).
     */
    corrected: boolean;
    ended_at: string | null;
    /**
     * Who closed the span; null while open.
     */
    ended_reason: group_presence_PresenceReportSegmentDTO.ended_reason | null;
    id: string;
    open: boolean;
    source: group_presence_PresenceReportSegmentDTO.source;
    started_at: string;
};
export namespace group_presence_PresenceReportSegmentDTO {
    /**
     * Who closed the span; null while open.
     */
    export enum ended_reason {
        EMPLOYEE = 'employee',
        SWITCH = 'switch',
        SHIFT_END = 'shift_end',
        DAY_END = 'day_end',
        ADMIN = 'admin',
    }
    export enum source {
        EMPLOYEE_APP = 'employee_app',
        EMPLOYEE_APP_LATE = 'employee_app_late',
        ADMIN = 'admin',
    }
}

